"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledRect = exports.StyledPath = exports.StyledG = void 0;
var _mui = require("@ori-ui/mui");
const StyledG = exports.StyledG = (0, _mui.styled)('g')(() => ({
  isolation: 'isolate'
}));
const StyledRect = exports.StyledRect = (0, _mui.styled)('rect')(() => ({
  fill: 'url(#linear-gradient)'
}));
const StyledPath = exports.StyledPath = (0, _mui.styled)('path')(({
  theme
}) => ({
  fill: theme.palette.common.white
}));
